import React from "react";
import { MdOutlineContentCopy } from "react-icons/md";
import styles from "./LinkCopy.module.css";

const LinkCopy = ({ link }) => {
  return (
    <div className={`alert alert-primary ${styles.content}`} role="alert">
      <div>{link?.substring(0, 50)}...</div>
      <div>
        <MdOutlineContentCopy
          onClick={() => navigator.clipboard.writeText(link)}
        />
      </div>
    </div>
  );
};

export default LinkCopy;
